var btnClass = '.product .product-page .product__information .purchase-details__buttons .button--add-to-cart';

Element.prototype.appendAfterThis = function (element) {
	element.parentNode.insertBefore(this, element.nextSibling);
};

var sticky = document.createElement('div');
sticky.innerHTML = `<div class="simple-st-container" id="simple-st-containerID"> <div class="simple-st-container__outer"><div class="simple-product-cont"><div class="simple-product-name"></div>
</div> <div class="simple-st-container__inner"><div class="simple-product-price"></div> <div class="simple-select-container"> <div class="simple-st-select" id="st-select0"> <span>Color</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select1"> <span>Type</span> <select> <option></option> </select> </div><div class="simple-st-select" id="st-select2"> <span>Type</span> <select> <option></option> </select> </div></div><div class="simple-st-item_column__button"><a class="simple-st-item__button" rel="nofollow">ADD TO CART</a></div></div></div></div>`;
var y = document.getElementsByTagName('body');
if (document.getElementsByClassName('simple-st-container').length == 0) {
	y[0].appendChild(sticky);

	jQuery('.simple-product-name').html(jQuery('h1.product_name.title').eq(0).html());
	let price = jQuery('p.modal_price.subtitle').eq(0).clone();
	if (price.find('.saved-price').length > 0) {
		price.find('.saved-price').remove();
	}
	if (price.find('.eu-pricing-directive').length > 0) {
		price.find('.eu-pricing-directive').remove();
	}
	jQuery('.simple-product-price').append(price);
	// jQuery('.simple-product-price').append(jQuery('p.modal_price.subtitle').eq(0).clone());

	jQuery('.simple-st-item__button').click(function () {
		jQuery('.purchase-details__buttons .button--add-to-cart').click();
	});
}

function checkIfDisabled() {
	setTimeout(function () {
		var elem = jQuery(btnClass).eq(0);
		jQuery('.simple-st-item__button').html('ADD TO CART');
		if (elem.is(':disabled')) {
			jQuery('.simple-st-item__button').html(elem.html());
			jQuery('.simple-st-item__button').addClass('simple-st-disabled');
		} else {
			jQuery('.simple-st-item__button').html('ADD TO CART');
			jQuery('.simple-st-item__button').removeClass('simple-st-disabled');
		}
	}, 100);
}

checkIfDisabled();

function isVisible(elem) {
	var elementTop = elem.offset().top;
	var elementBottom = elementTop + elem.outerHeight();
	var viewportTop = jQuery(window).scrollTop();
	var viewportBottom = viewportTop + jQuery(window).height();
	return elementBottom > viewportTop && elementTop < viewportBottom;
}

var mc = window.matchMedia('(min-width: 767px)');

var elem = document.getElementById('simple-st-containerID');
function slideShow() {
	jQuery('body').addClass('simple-sticky');
}

function slideHide() {
	jQuery('body').removeClass('simple-sticky');
}

jQuery(document).scroll(function () {
	var y = jQuery(this).scrollTop();
	if (y > jQuery('.purchase-details__buttons .button--add-to-cart').eq(0).offset().top) {
		slideShow();
	} else {
		slideHide();
	}
});
